import { create } from "zustand";

import {
  recordToJs,
  getDefaults,
  validateForm,
  recToTryton,
  genStoreId,
} from "componentsv2/tools/functions";
import { getFromId } from "./common";
import { getStorage } from "store/local";
import proxy from "api/proxy";

function updateDataTable(record, parentRec, recParent) {
  const targetField = parentRec.fieldName;
  const mapStore = recParent.store[targetField];
  const mapActive = recParent.active[targetField];

  const action = record.active.id > 0 ? "write" : "create";
  const rows = mapStore.get(action);
  const rowsMap = rows.set(record.active.id, recToTryton(record.active));
  mapStore.set(action, rowsMap);

  if (action === "create") {
    // fix this @vic
    if (Array.isArray(mapActive)) {
      // mapActive = new Map(mapActive.map((item) => [item.id, item]));
      // mapActive.set(record.active.id, record.active);
      mapActive.push(record.active);
    } else if (mapActive.value instanceof Map) {
      mapActive.value.set(record.active.id, record.active);
    }
  }

  recParent.active[targetField] = mapActive;
  return recParent;
}

const useStore = create((set, get) => ({
  findRecord: (storeId) => {
    const state = get();
    return state[storeId];
  },
  setRecord: async (recId, model, layout) => {
    console.log("setRecord: Deprecation warning use insertRecord instead...!");
    if (recId < 0) {
      return;
    }
    const storeId = genStoreId(model, recId);
    const record = await getFromId(recId, model, layout);
    const recordData = {};
    recordData[storeId] = {
      store: { id: recId },
      active: record,
      layout: layout,
      storeId: storeId,
    };
    set((state) => ({ ...state, ...recordData }));
  },
  deleteRecord: async (model, recordId) => {
    return await proxy.remove({
      model: model,
      ids: [recordId],
    });
  },
  saveForm: async (storeId) => {
    const state = get();
    const rec = state[storeId];
    const { layout } = rec;
    const res = validateForm(rec, rec.store, layout.fields);
    if (res.msg !== "ok") {
      return { type: "error", msg: res.msg };
    }
    for (const [fieldName, fieldDef] of Object.entries(layout.fields)) {
      if (typeof fieldDef.validate === "function") {
        const value = rec.store[fieldName] ?? rec.active[fieldName];
        const result = fieldDef.validate({ value });
        if (typeof result === "string") {
          return { type: "error", msg: result };
        }
      }
    }
    const recordToSave = recToTryton(rec.store);
    if (typeof layout.beforeSave === "function" )
      await layout.beforeSave(recordToSave, rec);
    // console.log("rec saveForm....", recordToSave);
    const { data, error } = await proxy.saveQuery({
      model: layout.model,
      storeRec: recordToSave,
    });
    // console.log("data....", data);
    if (error) {
      return { type: error.type, msg: error.error };
    }
    let recId = rec.store.id;
    // We need preprocess data
    if (data) {
      if (Array.isArray(data)) {
        recId = data[0];
      } else {
        const rec = recordToJs(data);
        recId = rec.id;
      }
    }

    const record = await getFromId(recId, layout.model, layout);

    const newStoreId = genStoreId(layout.model, recId);
    const updatedRecord = {
      ...rec,
      store: { id: recId },
      active: record,
    };

    set((state) => {
      const newState = { ...state, [storeId]: updatedRecord };
      if (storeId !== newStoreId) {
        newState[newStoreId] = updatedRecord;
      }
      return newState;
    });
    return { msg: "board.record_saved", type: "info", data };
  },
  reset: (full) => {
    // This is necessary?
    if (full) {
      set({ store: {}, record: {} });
    } else {
      set({ store: { id: get().record.id } });
    }
  },
  reload: async (storeId) => {
    const findRecord = get().findRecord;
    console.log("reload desde formStore .....", storeId);
    const rec = findRecord(storeId);
    const record = await getFromId(rec.active.id, rec.layout.model, rec.layout);
    console.log("REacargando....", record);
    const currentRecord = {};

    currentRecord[storeId] = {
      store: { id: record.id },
      active: record,
      layout: rec.layout,
    };
    set((state) => {
      const newState = { ...state, ...currentRecord };
      return newState;
    });
    return storeId;
  },
  newRecord: async (layout, parentRec) => {
    const session = await getStorage("ctxSession");
    const [_store, _active] = await getDefaults(0, layout);
    if (parentRec) {
      const { target, record: parent } = parentRec;
      _store[target] = parent.id;
    }
    const timeStamp = Date.now();
    const recId = -(timeStamp + session.user * 10 ** 13);
    _store.id = recId;
    _active.id = recId;
    const storeId = genStoreId(layout.model, recId);
    const recordData = {};
    recordData[storeId] = {
      store: _store,
      active: _active,
      layout,
    };
    set((state) => ({
      ...state,
      ...recordData,
    }));
    return storeId;
  },
  updateForm: (storeId, active, store) => {
    const state = get();
    const record = state[storeId];
    const recordData = {};
    if (active) {
      record.active = active;
    }
    if (store) {
      record.store = store;
    }
    recordData[storeId] = { ...record };
    set((state) => ({
      ...state,
      ...recordData,
    }));
  },
  updateRecord: (activeNew, storeNew, model, recordId) => {
    console.log("updateRecord: Deprecation warning use updateForm instead...!");
    const storeId = genStoreId(model, recordId);
    const state = get();
    const record = state[storeId];
    const recordData = {};
    recordData[storeId] = { ...record, store: storeNew, active: activeNew };
    set((state) => ({
      ...state,
      ...recordData,
    }));
    return storeId;
  },
  updateParentForm: (record, parentRec) => {
    const findRecord = get().findRecord;
    const recParent = findRecord(parentRec.storeId);
    if (!recParent) {
      console.error(
        "updateParentForm: parent record not found for storeId",
        parentRec.storeId,
      );
      return;
    }
    const updatedParent = updateDataTable(record, parentRec, recParent);
    const updatedState = {};
    updatedState[parentRec.storeId] = { ...recParent };
    set((state) => ({ ...state, ...updatedState }));
  },
  updateToParent: (record, parentRec) => {
    console.log(
      "updateToParent: Deprecation warning use updateParentForm instead...!",
    );
    const findRecord = get().findRecord;
    const recParent = findRecord(parentRec.storeId);
    if (!recParent) {
      console.error(
        "updateToParent: parent record not found for storeId",
        parentRec.storeId,
      );
      return;
    }
    const updatedParent = updateDataTable(record, parentRec, recParent);
    const updatedState = {};
    updatedState[parentRec.storeId] = { ...recParent };
    set((state) => ({ ...state, ...updatedState }));
  },
}));

const useRecord = (dataID) => {
  // Use a selector to pick the specific slice of state needed, defaulting to 0 if not found
  return useStore((state) => state[dataID]);
};

const insertRecord = async (recId, model, layout) => {
  // console.log("Dentro de insertRecord", recId);
  if (recId < 0) {
    // console.log("no encontre nada ????????");
    return;
  }
  const storeId = genStoreId(model, recId);
  const record = await getFromId(recId, model, layout);
  const recordData = {};
  recordData[storeId] = {
    store: { id: recId },
    active: record,
    layout: layout,
  };
  useStore.setState((state) => ({
    ...state,
    ...recordData,
  }));
  return storeId;
};

const findRecord2 = (storeId) => {
  // Experimental
  const state = useStore.getState();
  return state[storeId];
};

export { useStore, useRecord, insertRecord, findRecord2 };
